import React, { useContext, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { Tab } from 'react-bootstrap'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { Tabs } from '../../../components/Tabs/Tabs'
import { HeaderContext } from '../../LayoutWithLeftSidebar/HeaderContext'
import { IntegrationManagementHeader } from '../../Integration/IntegrationManagement/IntegrationManagementHeader'
import { OAuth2AppsPermissionsTab } from './OAuth2AppsPermissionsTab'
import { OAuth2App } from '../../../store/auth/auth'
import { OAuth2AppsAboutTab } from './OAuth2AppsAboutTab'

export interface OAuth2AppsManagementTabsProps {
  oAuth2App: OAuth2App
}

export const OAuth2AppsManagementTabs: React.FC<OAuth2AppsManagementTabsProps> = ({ oAuth2App }) => {
  const { description } = oAuth2App
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { portalRef } = useContext(HeaderContext)

  const { appId, activeTab = 'about' } = useParams<{
    appId: string
    activeTab?: string
  }>() as { appId: string; activeTab?: string }

  const handleTabSelect = (key: string | null) => {
    if (key && key !== activeTab) {
      navigate(
        {
          pathname: `/account/integration-settings/oauth2apps/${appId}/${key}`,
          search: searchParams.toString(),
        },
        { replace: false },
      )
    }
  }

  const [headerContainer, setHeaderContainer] = useState<HTMLElement | null>(null)
  useEffect(() => {
    if (portalRef && portalRef.current) {
      setHeaderContainer(portalRef.current)
    }
  }, [portalRef])

  return (
    <>
      {headerContainer ? createPortal(<IntegrationManagementHeader backTarget={'app'} />, headerContainer) : null}

      <Tabs className='mb-6' id='integration-management-tabs' defaultActiveKey={activeTab} activeKey={activeTab} onSelect={handleTabSelect}>
        <Tab eventKey='about' title='About'>
          <OAuth2AppsAboutTab description={description} />
        </Tab>

        <Tab eventKey='permissions' title='Permissions'>
          {activeTab === 'permissions' && <OAuth2AppsPermissionsTab oAuth2App={oAuth2App} />}
        </Tab>
      </Tabs>
    </>
  )
}
